import {
  FlatInteractionModelData,
  NestableGroupValue,
  ActivityValue,
  FlatActivityModel
} from 'types/shared'
import { ActivityTransformersMap } from './ActivityTransformer.types'

const getTransformedActivities = async (
  activities: FlatInteractionModelData['activity_values'],
  activityModels: Record<string, Pick<FlatActivityModel, 'content_type'>>,
  transformers: ActivityTransformersMap
) => {
  const transformValue = async (
    value: NestableGroupValue | ActivityValue,
    activityModelUuid: string
  ) => {
    const contentType = activityModels[activityModelUuid].content_type
    const transformer =
      contentType !== 'activity_group' && transformers[contentType]

    if (transformer && !Array.isArray(value)) {
      return await transformer(value)
    }

    return value
  }

  const transformedActivities: FlatInteractionModelData['activity_values'] = {}
  for (const [activityModelUuid, value] of Object.entries(activities)) {
    if (Array.isArray(value)) {
      transformedActivities[activityModelUuid] = await Promise.all(
        value.map(async (group) => ({
          uuid: group.uuid,
          values: await getTransformedActivities(
            group.values,
            activityModels,
            transformers
          )
        }))
      )
    } else {
      transformedActivities[activityModelUuid] = await transformValue(
        value,
        activityModelUuid
      )
    }
  }

  return transformedActivities
}

export default getTransformedActivities
